module.exports = __webpack_public_path__ + "img/404.4b1608e7.png";